import { useContext } from "react";
import TGButton from "src/components/ui/TGButton";
import { TestRegistryContext } from "../../store/testRegistryContext";
import { setAddQuestion, setOpenForm } from "../../store/testRegistryActions";
import { useFormContext } from "react-hook-form";

export const BtnAddQuestion = () => {
  const { state, dispatchTestRegistry } = useContext(TestRegistryContext);
  const { setValue } = useFormContext();

  const addNewQuestion = () => {
    dispatchTestRegistry(setOpenForm(true));
    setValue("MinCorrectAnswersCount", state.minCorrectAnswersCount);

    dispatchTestRegistry(setAddQuestion(true));
  };

  return (
    <div className="text-center">
      <TGButton className="w-full" onClick={addNewQuestion}>
        Добавить вопрос
      </TGButton>
    </div>
  );
};
